import React from 'react';
import { Col } from 'react-bootstrap';

export const Fact = ({ title, count, symbol }) => (
	<Col className="column count-box" lg={3} md={3} sm={6} xs={12}>
		<div className="inner">
			<div className="content">
				<div className="count-outer">
					<span className="count-text" data-speed="1000" data-stop={count}>0</span>{symbol}
				</div>
				<div className="counter-title">{title}</div>
			</div>
		</div>
	</Col>
);



// WEBPACK FOOTER //
// ./src/components/ui/Facts/Fact.js